import axios from 'axios';


const directionsApi = axios.create({
    baseURL: 'https://api.mapbox.com/directions/v5/mapbox/driving',
    params: {
        alternatives: false,
        geometries: 'geojson',
        overview: 'simplified',
        steps: false,
        access_token: 'pk.eyJ1IjoiaWFtYm9ubmUiLCJhIjoiY2x6MXZycjh0MDRoNjJrb2c5ZzVkOXZweCJ9.YvjY8yFRvS1GPF9MXhCgmg'
    }
});


export default directionsApi;


